import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from 'react-hot-toast';
import HomePage from './pages/HomePage';
import Irreplaceable from './pages/Irreplaceable';
import ProtectedRoute from './routes/ProtectedRoute';
import Register from './pages/Register';
import SignIn from './pages/SignIn';
import UserDashboard from './pages/UserDashboard';
import UserProfile from './pages/UserProfile';
import ContactPage from './pages/ContactPage';
import ApprovalPending from './pages/ApprovalPending';
import SelfAssessment from './pages/SelfAssessment';
import ThankYou from './pages/ThankYou';
import DISCAssessment from './pages/DISCAssessment';
import NominateEvaluators from './pages/NominateEvaluators';
import Report from './pages/Report';
import ExampleReport from './pages/ExampleReport';
import TestPage from './pages/TestPage';
import ProvideContext from './pages/ProvideContext';
import OnboardingTutorial from './pages/OnboardingTutorial';
import EvaluationAccess from './pages/EvaluationAccess';
import EvaluationForm from './pages/EvaluationForm';
import PageTransition from './components/PageTransition';
import ScrollToTop from './components/ScrollToTop';
import ReportGuard from './guards/ReportGuard';
import CookieConsent from './components/CookieConsent';
import EmailCopyModal from './components/modals/EmailCopyModal';

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <CookieConsent />
        <Toaster position="top-right" />
        <ScrollToTop />
        <EmailCopyModal />
        <PageTransition isVisible={true}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/irreplaceable" element={<Irreplaceable />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/register" element={<Register />} />
            <Route path="/approval-pending" element={<ApprovalPending />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/evaluation/:evaluatorEmail" element={<EvaluationAccess />} />
            <Route path="/evaluation-form/:token" element={<EvaluationForm />} />
            <Route path="/thankyou/:evaluatorId" element={<ThankYou />} />
            <Route path="/example-report" element={<ExampleReport />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <UserDashboard />
              </ProtectedRoute>
            } />
            
            <Route path="/profile" element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            } />
            
            <Route path="/onboarding-tutorial" element={
              <ProtectedRoute>
                <OnboardingTutorial />
              </ProtectedRoute>
            } />
            
            <Route path="/disc-assessment" element={
              <ProtectedRoute>
                <DISCAssessment />
              </ProtectedRoute>
            } />
            
            <Route path="/self-assessment" element={
              <ProtectedRoute>
                <SelfAssessment />
              </ProtectedRoute>
            } />
            
            <Route path="/nominate-evaluators" element={
              <ProtectedRoute>
                <NominateEvaluators />
              </ProtectedRoute>
            } />

            <Route path="/report" element={
              <ProtectedRoute>
                <ReportGuard>
                  <Report />
                </ReportGuard>
              </ProtectedRoute>
            } />

            <Route path="/test" element={
              <ProtectedRoute>
                <TestPage />
              </ProtectedRoute>
            } />

            <Route path="/provide-context" element={
              <ProtectedRoute>
                <ProvideContext />
              </ProtectedRoute>
            } />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </PageTransition>
      </Router>
    </AuthProvider>
  );
}